import { useState } from "react";
import { toast } from "react-toastify";

const ForgotPassword = () => {
    const [empId, setEmpId] = useState('');

    const resetHandle = async (event) => {
        event.preventDefault();

        fetch('/api/v1/forgotPassword', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ employeeId: empId })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    toast.success("Sent a link to your email", {
                        autoClose: 5000, position: "top-right"
                    });
                } else {
                    toast.error(data.message, {
                        autoClose: 5000, position: "top-right"
                    });
                }
            })
            .catch(err => console.error(err));
    };

    return (
        <>
            <div className="logo">
                <img src="/images/logo-circle-dark.png" alt="logo" className="circle"/>
                <img src="/images/brevia-brown.png" className="brevia"></img>
            </div>
            <div className="logo-wrapper">
                <div className="login-wrapper">
                    <h2>Forgot Password?</h2>
                    <form onSubmit={resetHandle} className="emp_form">
                        <label htmlFor="forgot-emp-id">Your Email address</label>
                        <div className="input_wrapper">
                            <input
                                id="forgot-emp-id"
                                type="text"
                                placeholder="Enter your email address"
                                value={empId}
                                onChange={(e) => setEmpId(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit">Send Reset Link</button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;